module.exports = __webpack_public_path__ + "static/media/foodndrinks_transitional_marker.5e7adf10.svg";